import {getValue, setValue} from "@/utils/sessionStorage";
/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

const baseURL = process.env.VUE_APP_BASE_API

// 日期格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

// 表单重置
export function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  const search = params;
  search.query.params = {};
	if (null != dateRange && '' != dateRange) {
		if (typeof(propName) === "undefined") {
      search.query.params["beginTime"] = dateRange[0];
      search.query.params["endTime"] = dateRange[1];
		} else {
      search.query.params["begin" + propName] = dateRange[0];
      search.query.params["end" + propName] = dateRange[1];
		}
	}
	return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
	const actions = [];
	Object.keys(datas).some((key) => {
		if (datas[key].dictValue === ('' + value)) {
			actions.push(datas[key].dictLabel);
			return true;
		}
	})
	return actions.join('');
}
// 回显数据名
export function selectDataLabel(datas, value,dictValue='dictValue',dictLabel='dictLabel') {
	const actions = [];
	Object.keys(datas).some((key) => {
		if (datas[key][dictValue] === ('' + value)) {
			actions.push(datas[key][dictLabel]);
			return true;
		}
	})
	return actions.join('');
}
// 回显牧场
export function selectRanchName(datas, value) {
	const actions = [];
	Object.keys(datas).some((key) => {
		if (datas[key].code === ('' + value)) {
			actions.push(datas[key].name);
			return true;
		}
	})
	return actions.join('');
}
// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
	const actions = [];
	const currentSeparator = undefined === separator ? "," : separator;
	const temp = value.split(currentSeparator);
	Object.keys(value.split(currentSeparator)).some((val) => {
		Object.keys(datas).some((key) => {
			if (datas[key].dictValue === ('' + temp[val])) {
				actions.push(datas[key].dictLabel + currentSeparator);
			}
		})
	})
	return actions.join('').substring(0, actions.join('').length - 1);
}


// 字符串格式化(%s )
export function sprintf(str) {
	let args = arguments, flag = true, i = 1;
	str = str.replace(/%s/g, function () {
		const arg = args[i++];
		if (typeof arg === 'undefined') {
			flag = false;
			return '';
		}
		return arg;
	});
	return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
	if (!str || str == "undefined" || str == "null") {
		return "";
	}
	return str;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
	id = id || 'id'
	parentId = parentId || 'parentId'
	children = children || 'children'
	rootId = rootId || Math.min.apply(Math, data.map(item => { return item[parentId] })) || "0"
	//对源数据深度克隆
	const cloneData = JSON.parse(JSON.stringify(data))
	//循环所有项
	const treeData = cloneData.filter(father => {
		let branchArr = cloneData.filter(child => {
			//返回每一项的子级数组
			return father[id] === child[parentId]
		});
		branchArr.length > 0 ? father.children = branchArr : '';
		//返回第一层
		return father[parentId] === rootId;
	});
	return treeData != '' ? treeData : data;
}

/**
 * 关闭当前页面并跳到另一个页面
 * @param closePath
 * @param toPath
 */
export function closeAndToPage(closePath,toPath) {
	let visitViews = JSON.parse(getValue("visitViews"));
	let closeTab = visitViews.find((item)=>{
		return item.path === closePath
	})
	visitViews = visitViews.filter(item => item.path!==closePath);
	setValue("visitViews", JSON.stringify(visitViews));
	this.$store.dispatch('tagsView/delVisitView', closeTab).then(() => {
		this.$router.push({path: toPath});
	})
}

// 下载
export function downloadBlobFile(resBlob,name){
	let filename = name;
	const blob = new Blob([resBlob]);
	const downloadElement = document.createElement("a");
	const href = window.URL.createObjectURL(blob);
	downloadElement.href = href;
	downloadElement.download = decodeURIComponent(filename);
	document.body.appendChild(downloadElement);
	downloadElement.click();
	document.body.removeChild(downloadElement);
	window.URL.revokeObjectURL(href);
}

//下载图片
export function downloadImage(url, name) {
	
	const link = document.createElement('a');
	link.href = url;
	link.download = name || url.split('/').pop() || 'download';
	link.style.display = 'none';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	
}

/**
 * 复制的方法
 * text: 要复制的内容
 * callback: 回调
 */
 export  function copyText(text, callback){ 
    var cinput = document.createElement('textarea'); // 动态创建textarea元素
    cinput.value = text; // 把需要复制的内容赋值到textarea的vlaue上
    cinput.setAttribute('readOnly', 'true');
    //注意大小写，不写的话手机端会自动弹出输入框
    document.body.appendChild(cinput); // 把创建的textarea元素添加进body元素内
    cinput.select(); // 选择对象
    document.execCommand("Copy"); // 执行浏览器复制命令
    cinput.className = 'oInput';
    cinput.style.display = 'none';
    cinput.style.opacity = '0';
    if(callback) {callback(text)}
}
// 上一个月
export function lastMonthDate() {
	var Nowdate = new Date();
	var vYear = Nowdate.getFullYear();
	var vMon = Nowdate.getMonth() + 1;
	var vDay = Nowdate.getDate();
	var daysInMonth = new Array(0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
	if (vMon == 1) {
		vYear = Nowdate.getFullYear() - 1;
		vMon = 12;
	} else {
		vMon = vMon - 1;
	}
	//闰年
	if ( vYear % 4 == 0 && vYear % 100 != 0 || vYear % 400 == 0) {
		daysInMonth[2] = 29;
	}
	if (daysInMonth[vMon] < vDay) {
		vDay = daysInMonth[vMon];
	}
	if (vDay < 10) {
		vDay = "0" + vDay;
	}
	if (vMon < 10) {
		vMon = "0" + vMon;
	}
	var date = vYear + "-" + vMon ;
	return date;
}
  //省级地址码校验
  let checkProv = function (val) {
	var pattern = /^[1-9][0-9]/;
	var provs = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门"};
	if(pattern.test(val)) {
		if(provs[val]) {
			return true;
		}
	}
	return false;
  }
  //出生日期码校验
  let  checkDate = function (val) {
	var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
	if(pattern.test(val)) {
		var year = val.substring(0, 4);
		var month = val.substring(4, 6);
		var date = val.substring(6, 8);
		var date2 = new Date(year+"-"+month+"-"+date);
		if(date2 && date2.getMonth() == (parseInt(month) - 1)) {
			return true;
		}
	}
	return false;
  }
  //校验码校验
  let checkCode = function (val) {
	var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
	var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
	var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
	var code = val.substring(17);
	if(p.test(val)) {
		var sum = 0;
		for(var i=0;i<17;i++) {
			sum += val[i]*factor[i];
		}
		if(parity[sum % 11] == code.toUpperCase()) {
			return true;
		}
	}
	return false;
  }
  //身份证规则校验
export function validateIDnumber(val) {
	if(checkCode(val)) {
		var date = val.substring(6,14);
		if(checkDate(date)) {
			if(checkProv(val.substring(0,2))) {
				return true;
			}
		}
	}
	return false;
  }